import DOMPurify from "dompurify";

/**
 * Allowed tags/attributes for the event description rich text.
 *
 * Acceptance criteria: support Bold, Italic, Underline, Strikethrough and
 * ordered/unordered lists ONLY. Everything else (links, images, videos,
 * files, headings, etc.) must be stripped automatically.
 */
const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "del",
  "strike",
  "ol",
  "ul",
  "li",
];

const ALLOWED_ATTR: string[] = [];

/**
 * Sanitize an HTML string from the rich text editor, keeping only the
 * whitelisted formatting. Disallowed markup is removed but its text content
 * is preserved.
 */
export const sanitizeRichText = (dirty?: string | null): string => {
  if (!dirty) return "";
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Drop disallowed tags but keep their text so pasted content isn't lost.
    KEEP_CONTENT: true,
  });
};

/**
 * True when the HTML has no human-visible content (used for "required"
 * validation, since an "empty" editor still emits "<p></p>").
 */
export const isRichTextEmpty = (html?: string | null): boolean => {
  if (!html) return true;
  const text = html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
  return text.length === 0;
};
